import { render, staticRenderFns } from "./examineList.vue?vue&type=template&id=24766047"
import script from "./examineList.vue?vue&type=script&lang=js"
export * from "./examineList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data01/test/dev.console.insureforce.cn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24766047')) {
      api.createRecord('24766047', component.options)
    } else {
      api.reload('24766047', component.options)
    }
    module.hot.accept("./examineList.vue?vue&type=template&id=24766047", function () {
      api.rerender('24766047', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/examine/claimRecordUsedManage/examineList.vue"
export default component.exports